import {createSelector} from 'reselect';

const getRootModal = (state: any) => state.rootModal;

export const selectRootModal = createSelector([getRootModal], modal => modal);
